import { render, staticRenderFns } from "./couponsRules.vue?vue&type=template&id=d07c9524&scoped=true&"
import script from "./couponsRules.vue?vue&type=script&lang=js&"
export * from "./couponsRules.vue?vue&type=script&lang=js&"
import style0 from "./couponsRules.vue?vue&type=style&index=0&id=d07c9524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07c9524",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d07c9524')) {
      api.createRecord('d07c9524', component.options)
    } else {
      api.reload('d07c9524', component.options)
    }
    module.hot.accept("./couponsRules.vue?vue&type=template&id=d07c9524&scoped=true&", function () {
      api.rerender('d07c9524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/couponsRules.vue"
export default component.exports